import type { ModuleRoute } from '../types';
import { FormsPage } from './FormsPage';
import { OutlookConnectPage } from './OutlookConnectPage';
import { OutlookTaskPane } from './OutlookTaskPane';

/**
 * Pages of this area: the pre-registration forms admin page and the Outlook add-in (task pane and connect page, ADR 0033).
 * Owned by Phase 4 task W30; only that task edits files in this folder (W32 wires it last).
 * The task pane is public (no shell): it signs in with a user token kept in the add-in's roaming settings.
 * The connect page needs a normal portal sign-in, because it creates that token for the signed-in user.
 */
export const routes: ModuleRoute[] = [
  { path: '/manage/forms', element: <FormsPage />, permission: 'forms.view' },
  { path: '/outlook/taskpane', element: <OutlookTaskPane />, public: true, area: 'any' },
  { path: '/outlook/connect', element: <OutlookConnectPage />, area: 'tenant' },
];
